import { RoutePaths } from './constants';

export const getRoute = (route: RoutePaths, id: string | number) => {
  return route.replace(`:id`, id.toString());
};
export const getRoute1 = (
  route: string,
  id: string | number,
  query?: Record<string, string | number>
) => {
  let path = route.replace(":id", id.toString());

  if (query) {
    path +=
      "?" +
      new URLSearchParams(
        Object.entries(query).reduce(
          (acc, [k, v]) => ({ ...acc, [k]: String(v) }),
          {}
        )
      ).toString();
  }

  return path;
};


export const reload = () => {
  window.location.reload();
};

export const noExtraSpaces = (_: any, value: string) => {
  if (!value) return Promise.resolve();

  // ❌ Leading or trailing spaces
  if (value.trim() !== value) {
    return Promise.reject("Name cannot start or end with spaces.");
  }

  // ❌ Multiple spaces inside name
  if (/\s{2,}/.test(value)) {
    return Promise.reject("Name cannot contain multiple spaces.");
  }

  return Promise.resolve();
};
export const capitalizeFirst = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();


   export function mergeGuids(guid1: string, guid2: string): string {
    const clean1 = guid1.replace(/-/g, '');
    const clean2 = guid2.replace(/-/g, '');

    const merged = clean1.slice(0, 16) + clean2.slice(0, 16);

    return `${merged.slice(0, 8)}-${merged.slice(8, 12)}-${merged.slice(12, 16)}-${merged.slice(16, 20)}-${merged.slice(20, 32)}`;
}